// NAVIEN OPTISLEEP — theme.js v10.0
// Cart drawer + all existing functionality

(function () {
  'use strict';

  // ── NAV scroll ──
  var nav = document.getElementById('site-nav');
  if (nav) {
    function onScroll() { nav.classList.toggle('scrolled', window.scrollY > 40); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── NAV mobile ──
  var burger = document.getElementById('navBurger');
  var mobileNav = document.getElementById('mobileNav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('open');
      burger.classList.toggle('open', isOpen);
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileNav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) {
        mobileNav.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
      }
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
      });
    });
  }

  // ── Scroll reveal ──
  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vis');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -48px 0px' });
    document.querySelectorAll('.sr').forEach(function (el) {
      /* If already in viewport on load, reveal immediately */
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('vis');
      } else {
        revealObs.observe(el);
      }
    });
  } else {
    document.querySelectorAll('.sr').forEach(function (el) { el.classList.add('vis'); });
  }

  // ── Smooth scroll ──
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var id = this.getAttribute('href');
      if (id === '#') return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        var navH = nav ? nav.offsetHeight : 0;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - navH - 16, behavior: 'smooth' });
      }
    });
  });

  // ══════════════════════════════════════════
  // CART DRAWER
  // ══════════════════════════════════════════

  var cartDrawerEl  = document.getElementById('cartDrawer');
  var overlayEl     = document.getElementById('cartDrawerOverlay');
  var cdItems       = document.getElementById('cdItems');
  var cdEmpty       = document.getElementById('cdEmpty');
  var cdFooter      = document.getElementById('cdFooter');
  var cdCount       = document.getElementById('cdCount');
  var cdSubtotal    = document.getElementById('cdSubtotal');
  var cdCheckoutBtn = document.getElementById('cdCheckoutBtn');

  function formatMoney(cents) {
    // Drop trailing .00 (e.g. $1,349 not $1,349.00); keep real cents when present ($1,349.25)
    var v = cents / 100;
    var s = (v % 1 === 0) ? String(v) : v.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateNavBadge(count) {
    var badge = document.getElementById('navCartBadge');
    if (count > 0) {
      if (badge) {
        badge.textContent = count;
      } else {
        var cartBtn = document.getElementById('navCartBtn');
        if (cartBtn) {
          var span = document.createElement('span');
          span.className = 'nav-cart-badge';
          span.id = 'navCartBadge';
          span.textContent = count;
          cartBtn.appendChild(span);
        }
      }
    } else {
      if (badge) badge.remove();
    }
    if (cdCount) cdCount.textContent = count;
  }

  function renderItems(cart) {
    if (!cdItems) return;

    if (cart.item_count === 0) {
      cdItems.innerHTML = '';
      if (cdEmpty) cdEmpty.hidden = false;
      if (cdFooter) cdFooter.style.display = 'none';
      return;
    }

    if (cdEmpty) cdEmpty.hidden = true;
    if (cdFooter) cdFooter.style.display = '';

    var html = '';
    cart.items.forEach(function (item, idx) {
      var imgHtml = item.image
        ? '<img src="' + item.image.replace(/(\.\w+)$/, '_140x140$1') + '" alt="' + item.product_title + '" loading="lazy">'
        : '<div class="cd-item-img-placeholder"><svg width="24" height="24" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="24" height="24" rx="2"/><path d="M4 20l6-6 4 4 4-6 10 8"/></svg></div>';

      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cd-item-variant">' + item.variant_title + '</div>'
        : '';

      var lineNum = idx + 1;

      var priceHtml;
      if (item.original_line_price && item.original_line_price !== item.line_price) {
        priceHtml = '<span class="cd-item-price-original">' + formatMoney(item.original_line_price) + '</span>'
          + '<span class="cd-item-price cd-item-price--sale">' + formatMoney(item.line_price) + '</span>';
      } else {
        priceHtml = '<span class="cd-item-price">' + formatMoney(item.line_price) + '</span>';
      }
      var discountTags = '';
      if (item.discounts && item.discounts.length) {
        item.discounts.forEach(function(d) {
          discountTags += '<span class="cd-discount-tag">' + d.title + '</span>';
        });
      }
      var qtyDec = '<button class="cd-qty-btn" onclick="cartDrawer.updateQty(\''
        + item.key + '\',' + (item.quantity - 1) + ',' + lineNum + ')" aria-label="Decrease"'
        + (item.quantity <= 1 ? ' disabled' : '') + '>'
        + '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>'
        + '</button>';
      var qtyInc = '<button class="cd-qty-btn" onclick="cartDrawer.updateQty(\''
        + item.key + '\',' + (item.quantity + 1) + ',' + lineNum + ')" aria-label="Increase">'
        + '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'
        + '</button>';
      var removeBtn = '<button class="cd-item-remove" onclick="cartDrawer.updateQty(\''
        + item.key + '\',0,' + lineNum + ')">Remove</button>';
      html += '<div class="cd-item" id="cd-item-' + item.key + '">'
        + '<div class="cd-item-img">' + imgHtml + '</div>'
        + '<div class="cd-item-info">'
        + '<a href="' + item.url + '" class="cd-item-title" onclick="cartDrawer.close()">' + item.product_title + '</a>'
        + variantLine
        + discountTags
        + '<div class="cd-item-bottom">'
        + '<div class="cd-qty">' + qtyDec + '<span class="cd-qty-val">' + item.quantity + '</span>' + qtyInc + '</div>'
        + '<div class="cd-item-price-wrap">' + priceHtml + '</div>'
        + removeBtn
        + '</div>'
        + '</div>'
        + '</div>';
    });

    cdItems.innerHTML = html;
    if (cdSubtotal) cdSubtotal.textContent = formatMoney(cart.total_price);
    updateNavBadge(cart.item_count);
  }

  function fetchAndRender() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderItems(cart); return cart; });
  }

  window.cartDrawer = {
    open: function () {
      if (!cartDrawerEl) return;
      fetchAndRender().then(function () {
        cartDrawerEl.classList.add('open');
        cartDrawerEl.setAttribute('aria-hidden', 'false');
        if (overlayEl) { overlayEl.classList.add('open'); overlayEl.setAttribute('aria-hidden', 'false'); }
        document.body.classList.add('drawer-open');
        var saved = sessionStorage.getItem('navien_discount');
        var input = document.getElementById('cdDiscountInput');
        if (saved && input) input.value = saved;
      });
    },
    close: function () {
      if (!cartDrawerEl) return;
      cartDrawerEl.classList.remove('open');
      cartDrawerEl.setAttribute('aria-hidden', 'true');
      if (overlayEl) { overlayEl.classList.remove('open'); overlayEl.setAttribute('aria-hidden', 'true'); }
      document.body.classList.remove('drawer-open');
    },
    updateQty: function (key, qty, line) {
      if (cdItems) cdItems.classList.add('loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: line ? JSON.stringify({ line: line, quantity: qty }) : JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderItems(cart); if (cdItems) cdItems.classList.remove('loading'); })
      .catch(function () { if (cdItems) cdItems.classList.remove('loading'); });
    },
    applyDiscount: function () {
      var input = document.getElementById('cdDiscountInput');
      var btn   = document.getElementById('cdDiscountBtn');
      var msg   = document.getElementById('cdDiscountMsg');
      var code  = input ? input.value.trim() : '';
      if (!code) { showMsg(msg, 'Please enter a discount code.', 'error'); return; }
      sessionStorage.setItem('navien_discount', code);
      if (cdCheckoutBtn) cdCheckoutBtn.href = '/checkout?discount=' + encodeURIComponent(code);
      showMsg(msg, '✓ "' + code + '" applied at checkout.', 'success');
    }
  };

  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'cd-discount-msg ' + type;
    el.hidden = false;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cartDrawer.close();
  });

  // ══════════════════════════════════════════
  // ADD TO CART — opens drawer on success
  // ══════════════════════════════════════════

  function addToCart(form) {
    var btn = form.querySelector('[name="add"]');
    if (!btn) return;
    var variantInput = form.querySelector('input[name="id"]');
    var variantId = variantInput ? variantInput.value : null;
    if (!variantId || variantId === '' || variantId === 'null') {
      btn.textContent = 'Please select a size';
      setTimeout(function () { btn.textContent = btn.dataset.orig || 'Add to Cart →'; }, 2000);
      return;
    }
    var orig = btn.textContent;
    btn.dataset.orig = orig;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    })
    .then(function () {
      btn.textContent = '✓ Added!';
      btn.style.background = '#2E7D32';
      cartDrawer.open();
      setTimeout(function () { btn.textContent = orig; btn.style.background = ''; btn.disabled = false; }, 2500);
    })
    .catch(function (err) {
      btn.textContent = err.message || 'Error — try again';
      btn.style.background = '#C62828';
      btn.disabled = false;
      setTimeout(function () { btn.textContent = orig; btn.style.background = ''; }, 3000);
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#product-form, #pdp-form, #nm-pdp-form');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  // ── Homepage variant selector ──
  window.selectVariant = function (btn, variantId, price, available) {
    var form = btn.closest('form');
    // Deactivate siblings — works with both .variant-btns and .product-variant-btns
    var wrap = btn.closest('.variant-btns') || btn.closest('.product-variant-btns');
    if (wrap) wrap.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    // Update hidden variant id input
    if (form) { var idInput = form.querySelector('input[name="id"]'); if (idInput) idInput.value = variantId; }
    // Update displayed price
    var priceEl = document.getElementById('productPrice');
    if (priceEl && price) priceEl.textContent = price;
    // Update ATC button state
    var atcBtn = document.getElementById('productAtcBtn');
    if (atcBtn) {
      var isAvailable = (available === true || available === 'true');
      atcBtn.disabled = !isAvailable;
      atcBtn.textContent = isAvailable ? 'Add to Cart →' : 'Sold Out';
    }
  };

  // ── Stay Cool Summer Special — shared expiry check (remove after Aug 3 2026) ──
  // Keep in sync with the PROMO_END value in the auto-expire block below
  // and with END_TS_MS in snippets/promo-launch-popup.liquid.
  var NV_PROMO_END_TS = 1785826740000; // Aug 3 2026 11:59 PM PDT (= Aug 4 2026 06:59 UTC) — extended from July 31
  function nvPromoExpired() { return Date.now() > NV_PROMO_END_TS; }

  // ── PDP variant selector ──
  window.pdpSelectVariant = function (btn) {
    var wrap = btn.closest('.pdp-buy-variants') || btn.closest('.pdp-variant-btns');
    if (wrap) wrap.querySelectorAll('.pdp-buy-variant, .pdp-variant-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    var id        = btn.getAttribute('data-variant-id');
    var price     = btn.getAttribute('data-price');
    var salePrice = btn.getAttribute('data-sale-price');
    var title     = btn.getAttribute('data-title');
    var form = document.getElementById('pdp-form');
    var vi = form ? form.querySelector('input[name="id"]') : document.getElementById('pdpVariantId');
    if (vi && id) vi.value = id;
    var pw = document.getElementById('pdpPriceWas');
    var pe = document.getElementById('pdpPrice');
    var sp = document.getElementById('pdpStickyPrice');
    if (nvPromoExpired()) {
      // Promo has ended — always show the regular price, never the stale sale price
      if (pe && price) pe.textContent = price;
      if (pw) pw.style.display = 'none';
      if (sp && price) sp.textContent = price;
    } else {
      // Price: show strikethrough original + differential sale price ($450/$500/$550 off)
      if (pw && price)     pw.textContent = price;
      if (pe && salePrice) pe.textContent = salePrice;
      if (sp && salePrice) sp.textContent = salePrice;
    }
    var sl = document.getElementById('pdpSizeLabel');   if (sl && title)     sl.textContent = title;
    var atc = document.getElementById('pdpAtcBtn');
    if (atc) atc.innerHTML = 'Add to Cart \u2192';
  };

  // ── Init: set was/sale price from active variant on page load ──
  (function() {
    var activeBtn = document.querySelector('.pdp-buy-variant.active');
    if (activeBtn) {
      var price     = activeBtn.getAttribute('data-price');
      var salePrice = activeBtn.getAttribute('data-sale-price');
      var pw = document.getElementById('pdpPriceWas');    if (pw && price)     pw.textContent = price;
      var pe = document.getElementById('pdpPrice');       if (pe && salePrice) pe.textContent = salePrice;
      var sp = document.getElementById('pdpStickyPrice'); if (sp && salePrice) sp.textContent = salePrice;
    }
  })();

  // ── PDP tabs ──
  window.pdpTab = function (btn, panelId) {
    document.querySelectorAll('.pdp-tab-btn').forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-selected', 'false'); });
    document.querySelectorAll('.pdp-tab-panel').forEach(function (p) { p.classList.remove('active'); p.hidden = true; });
    btn.classList.add('active'); btn.setAttribute('aria-selected', 'true');
    var panel = document.getElementById(panelId);
    if (panel) { panel.classList.add('active'); panel.hidden = false; }
  };

  // ── PDP FAQ ──
  window.pdpFaq = function (btn) {
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', !expanded);
    var a = btn.nextElementSibling; if (a) a.hidden = expanded;
  };

  // ── PDP add to cart (named function for sticky bar) ──
  window.pdpAddToCart = function () {
    var form = document.getElementById('pdp-form');
    if (form) addToCart(form);
  };

  // ── PDP sticky bar ──
  var stickyBar = document.getElementById('pdpStickyBar');
  var pdpMain   = document.getElementById('pdp-main');
  if (stickyBar && pdpMain) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var show = !e.isIntersecting;
        stickyBar.classList.toggle('visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 }).observe(pdpMain);
  }

  // ── PDP thumbnails ──
  window.pdpThumb = function (btn, src) {
    var img = document.getElementById('pdpActiveImg');
    if (img) img.src = src;
    document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
    btn.classList.add('active');
  };

  // ── Cart page ──
  window.cartUpdateQty = function (key, qty, line) {
    var items = document.getElementById('cartItems');
    if (items) items.classList.add('cart-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: line ? JSON.stringify({ line: line, quantity: qty }) : JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (qty === 0) { var el = document.getElementById('cart-item-' + key); if (el) el.remove(); }
      else {
        var qtyEl = document.getElementById('qty-' + key); if (qtyEl) qtyEl.textContent = qty;
        var lineEl = document.getElementById('line-' + key);
        if (lineEl) { var item = cart.items.find(function (i) { return i.key === key; }); if (item) lineEl.textContent = formatMoney(item.line_price); }
      }
      var sub = document.getElementById('cartSubtotal'); if (sub) sub.textContent = formatMoney(cart.original_total_price);
      var tot = document.getElementById('cartTotal');    if (tot) tot.textContent = formatMoney(cart.total_price);
      updateNavBadge(cart.item_count);
      if (cart.item_count === 0) location.reload();
      if (items) items.classList.remove('cart-updating');
    })
    .catch(function () { if (items) items.classList.remove('cart-updating'); location.reload(); });
  };
  window.cartRemove = function (key, line) { cartUpdateQty(key, 0, line); };

  window.cartApplyDiscount = function () {
    var input = document.getElementById('cartDiscountCode');
    var msg   = document.getElementById('cartDiscountMsg');
    var code  = input ? input.value.trim() : '';
    if (!code) { showMsg(msg, 'Please enter a code.', 'error'); return; }
    sessionStorage.setItem('navien_discount', code);
    var btn = document.querySelector('.cart-checkout-btn'); if (btn) btn.href = '/checkout?discount=' + encodeURIComponent(code);
    showMsg(msg, '✓ "' + code + '" applied at checkout.', 'success');
  };

  var discountInput = document.getElementById('cartDiscountCode');
  if (discountInput) {
    discountInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); cartApplyDiscount(); } });
    var saved = sessionStorage.getItem('navien_discount');
    if (saved) discountInput.value = saved;
  }


  // ── Homepage product carousel ──
  (function () {
    var track = document.getElementById('productCarouselTrack');
    if (!track) return;
    var slides = track.querySelectorAll('.product-carousel-slide');
    var dots   = document.querySelectorAll('.product-carousel-dot');
    var prev   = document.getElementById('productCarouselPrev');
    var next   = document.getElementById('productCarouselNext');
    var total  = slides.length;
    var current = 0;

    function goTo(idx) {
      current = (idx + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('active', i === current); });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(this.dataset.index, 10)); });
    });

    // Touch swipe
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });
  })();


  // ── Mobile swipe carousels: Why OptiSleep + Brochure ──
  (function () {
    function initSwipeCarousel(gridSel, dotSel) {
      var grid = document.querySelector(gridSel);
      var dots = document.querySelectorAll(dotSel);
      if (!grid || !dots.length) return;

      var cards = Array.from(grid.children).filter(function (el) {
        return !el.classList.contains('why-swipe-hint') &&
               !el.classList.contains('bro-swipe-hint') &&
               !el.classList.contains('why-dots') &&
               !el.classList.contains('bro-dots');
      });

      function updateDots() {
        var scrollLeft = grid.scrollLeft;
        var cardW = cards[0] ? cards[0].offsetWidth + 12 : 1;
        var active = Math.min(Math.round(scrollLeft / cardW), cards.length - 1);
        dots.forEach(function (d, i) { d.classList.toggle('active', i === active); });
      }

      grid.addEventListener('scroll', updateDots, { passive: true });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(this.dataset.index, 10);
          if (!cards[idx]) return;
          var cardW = cards[idx].offsetWidth + 12;
          grid.scrollTo({ left: idx * cardW, behavior: 'smooth' });
        });
      });
    }

    initSwipeCarousel('.why-grid', '.why-dots .swipe-dot');
    initSwipeCarousel('.brochure-grid', '.bro-dots .swipe-dot');
  })();


  // ══════════════════════════════════════
  // CARE+ ADD-ON TOGGLE
  // ══════════════════════════════════════
  window.pdpToggleCarePlus = function(checkbox) {
    var variantId = parseInt(checkbox.getAttribute('data-variant-id'), 10);
    if (!variantId) return;
    if (checkbox.checked) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status && data.status >= 400) {
          console.warn('Care+ add failed:', data.description);
          checkbox.checked = false;
        } else {
          fetchAndRender();
        }
      })
      .catch(function(err) { console.error('Care+ add error:', err); checkbox.checked = false; });
    } else {
      fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var line = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === variantId) { line = i + 1; break; }
        }
        if (line > 0) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: 0 })
          }).then(function(r) { return r.json(); }).then(renderItems);
        }
      });
    }
  };


// ── Stay Cool Summer Special — auto-expire on Aug 3 2026 11:59 PM PDT (extended from July 31) ──
(function() {
  var PROMO_END = 1785826740000; // Aug 3 2026 11:59 PM PDT (= Aug 4 2026 06:59 UTC) — extended from July 31

  function promoExpired() { return Date.now() > PROMO_END; }

  function removePromo() {
    // 1. Ann-bar
    var annBar = document.getElementById('annBar');
    if (annBar) {
      annBar.style.display = 'none';
      var siteNav = document.getElementById('site-nav');
      if (siteNav) { siteNav.style.top = '0'; siteNav.classList.add('bar-hidden'); }
      document.body.classList.add('bar-hidden');
    }

    // 2. Promo pills (homepage + PDP)
    document.querySelectorAll('.btheat-pdp-pill, .btheat-hp-pill').forEach(function(el) {
      el.style.display = 'none';
    });

    // 3. PDP main price — restore original (remove was, show only now as original)
    var pw = document.getElementById('pdpPriceWas');
    var pe = document.getElementById('pdpPrice');
    if (pw && pe) {
      // Move original price back into the main price span, hide strikethrough
      pe.textContent = pw.textContent;
      pw.style.display = 'none';
    }

    // 4. Variant buttons — hide sale price, restore original price style
    document.querySelectorAll('.pdp-variant-sale-price').forEach(function(el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.pdp-variant-price').forEach(function(el) {
      el.style.textDecoration = 'none';
      el.style.color = 'var(--ink-light)';
      el.style.fontSize = '12px';
    });

    // 5. Homepage product module price wrap — same as PDP
    var hpWas = document.querySelector('.product-price-was');
    var hpNow = document.querySelector('.product-price-now');
    if (hpWas && hpNow) {
      hpNow.textContent = hpWas.textContent;
      hpWas.style.display = 'none';
    }
  }

  if (promoExpired()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', removePromo);
    } else {
      removePromo();
    }
  }
})();

})();